// 暴力搜索检查b是否在arr中
export function simple_search<T>(
    arr: T[],
    compareFunc: (a: T) => number,
): number {
    if (!(arr && arr.length > 0)) {
        return -1;
    }
    const n = arr.length;
    for (let i = 0; i < n; i++) {
        if (compareFunc(arr[i]) === 0) {
            return i;
        }
    }
    return -1;
}

// 比较消息大小给simple_search函数用
export function msg_compare(a: any, b: any): number {
    if (!a) {
        return -1;
    }
    if (!b) {
        return 1;
    }
    if (!a.mid) {
        return -1;
    }
    if (!b.mid) {
        return 1;
    }
    if (a.mid > b.mid) {
        return 1;
    } else if (a.mid < b.mid) {
        return -1;
    } else {
        return 0;
    }
}

export function binary_search<T>(
    arr: T[],
    compareFunc: (a: T) => number,
): number {
    let low = 0;
    let high = arr.length - 1;
    while (low <= high) {
        const mid = Math.floor((high + low) / 2);
        if (compareFunc(arr[mid]) === 0) {
            return mid;
        } else if (compareFunc(arr[mid]) < 0) {
            low = mid + 1;
        } else if (compareFunc(arr[mid]) > 0) {
            high = mid - 1;
        } else {
            return -1;
        }
    }
    return -1;
}
